import React from 'react';
import Link from 'next/link';
import Slider from 'react-slick';
import ResultListItem from '@components/acca/test/accaTestList/resultListItem';
import SliderButton from '@components/common/sliderButton';
import { useAccCenterApplyRecent } from '@repository/acc';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { useApplyHistoryList } from '@repository/acc/useAcca';
import { RouteUrl } from '@utils/routeUtil';

import classnames from 'classnames/bind';
import styles from './accaTestList.module.scss';
import Colors from '@domain/constant/colors';
import Icon from '@components/common/assets';
const cx = classnames.bind(styles);

// 최근 응시 내역 없는 경우
const EmptyList = () => {
  return (
    <div className={cx('section')}>
      <div className={cx('sectionInner')}>
        <div className={cx('accaTestListArea')}>
          <strong className={cx('sectionTitle')}>최근 응시내역</strong>
          <div className={cx('sectionDescArea')}>
            <p className={cx('sectionDesc')}>최근 3개월 내 응시내역과 결과를 확인할 수 있어요.</p>
          </div>

          <div className={cx('emptyArea')}>최근 응시 내역이 없습니다.</div>
        </div>
      </div>
    </div>
  );
};

const PrevArrow = (props: any) => {
  const { className, style, onClick } = props;

  return (
    <SliderButton
      type={'prev'}
      slickClass={className}
      handleClick={onClick}
      style={{ ...style }}
      customClassName={cx('btnPrev')}
    />
  );
};

const NextArrow = (props: any) => {
  const { className, style, onClick } = props;

  return (
    <SliderButton
      type={'next'}
      slickClass={className}
      handleClick={onClick}
      style={{ ...style }}
      customClassName={cx('btnNext')}
    />
  );
};

const AccaTestList = () => {
  const { data: userData } = useUserInfo();
  const isLogin = !!userData?.id;
  const userName = userData?.name;
  const { data: applyRecentData } = useAccCenterApplyRecent(isLogin);
  const { data: applyHistoryData } = useApplyHistoryList(isLogin);

  if (!isLogin || !applyHistoryData || !userName) return null;

  const { url } = applyHistoryData;

  const settings = {
    infinite: false,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 300,
    cssEase: 'ease-in-out',
  };

  const accaTestListItems = applyRecentData?.applies?.map((item, index) => {
    return (
      <div className={cx('listItemWrap')} key={index}>
        <ResultListItem data={item} userName={userName} applyUrl={url} />
      </div>
    );
  });

  // [D] 최근 응시 내역 없는 경우
  if (applyRecentData?.applies?.length === 0) {
    return <EmptyList />;
  }

  return (
    <div className={cx('section')}>
      <div className={cx('sectionInner')}>
        <div className={cx('accaTestListArea')}>
          <div className={cx('sectionDescArea')}>
            <strong className={cx('sectionTitle')}>최근 응시내역</strong>
            <p className={cx('sectionDesc')}>최근 3개월 내 응시내역과 결과를 확인할 수 있어요.</p>
            <Link href={RouteUrl.ACCA_TEST_LIST} legacyBehavior>
              <a className={cx('sectionLink')} target="_blank" role="button">
                전체 보기
                <Icon name="arrowRightLight" width={24} height={24} fill={Colors.C_JOBDA_BLACK} />
              </a>
            </Link>
          </div>

          <div className={cx('accaTestListInner')}>
            <Slider {...settings}>{accaTestListItems}</Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccaTestList;
